(function(window, angular, undefined) {
angular.module('formApp')
    .directive('anzSortCode', [function () {
    
        var template = [
            '<div class="anz-sortcode" ng-model-options="{ updateOn: \'default blur\', debounce: { default: 0, blur: 0 } }">',
                '<div class="col s4 offset-lg3 lg2">',
                    '<label for="sortcode" id="sortcode1Title" class="accessibleHide">First two digits</label>',
                    '<input numbers-only type="tel" maxlength="2" id="sortcode1" name="s1" ng-model="s1" ng-blur="setTouched()" aria-labelledby="sortcodeTitle sortcode1Title sortcodeError" required />',
                '</div>',
                '<div class="col s4 lg2">',
                    '<label for="sortcode" id="sortcode2Title" class="accessibleHide">Second two digits</label>',
                    '<input numbers-only type="tel" maxlength="2" id="sortcode2" name="s2" ng-model="s2" ng-blur="setTouched()" aria-labelledby="sortcodeTitle sortcode2Title sortcodeError" required />',
                '</div>',
                '<div class="col s4 lg2">',
                    '<label for="sortcode" id="sortcode3Title" class="accessibleHide">Third two digits</label>',
                    '<input numbers-only type="tel" maxlength="2" id="sortcode3" name="s3" ng-model="s3" ng-blur="setTouched()" aria-labelledby="sortcodeTitle sortcode3Title sortcodeError" required />',
                '</div>',
            '</div>'
        ];
    
        return {
            restrict: 'A',
            replace: true,
            template: template.join(''),
            require: ['^form','ngModel'],
            scope: {
            anzValidateConstraints: "="
            },
    
            link: function(scope, elem, attrs, ctrls) {

            var model = ctrls[1],
                form = ctrls[0];
    
            scope.$watchCollection('[s1, s2, s3]', function () {
                if (scope.s1 && scope.s2 && scope.s3) {
                    model.$setViewValue("" + scope.s1 + scope.s2 + scope.s3);
                } else {
                    model.$setViewValue();
                }
            });

            scope.anzValidateConstraints.forEach(function(constraint) {
                if (constraint.type === "pattern") {
                    model.$validators.pattern = function(modelValue) {
                        var valid = new RegExp(constraint.value).test(modelValue);
                        form.s1.$setValidity('pattern', valid);
                        form.s2.$setValidity('pattern', valid);
                        form.s3.$setValidity('pattern', valid);

                        return valid;
                    };
                }
            });

            scope.setTouched = function() {
                model.$setTouched();
            };

            model.$render = function() {
                if (!model.$viewValue) {
                    return;
                }

                var m = model.$viewValue;
                scope.s1 = parseInt(m.slice(0,2));
                scope.s2 = parseInt(m.slice(2,4));
                scope.s3 = parseInt(m.slice(4,6));
            };

            }
        };
        }]);

})(window, window.angular);